module.exports = __webpack_public_path__ + "img/noun-logo-2.8186cab2.png";